import React, { useState } from "react";
import axios from "axios";

const AddPowerGenerationPlant = () => {
  const [formData, setFormData] = useState({
    genplant_name: "",
    genplant_address: "",
    genplant_city: "",
    genplant_district: "",
    genplant_state: "",
    genplant_pincode: "",
    genplant_phone: "",
    genplant_email: "",
    genplant_website: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      await axios.post("https://backend-zkgn.onrender.com/api/plants", formData);
      setMessage("✅ Power Generation Plant added successfully!");
      setFormData({
        genplant_name: "",
        genplant_address: "",
        genplant_city: "",
        genplant_district: "",
        genplant_state: "",
        genplant_pincode: "",
        genplant_phone: "",
        genplant_email: "",
        genplant_website: "",
      });
    } catch (error) {
      console.error("Error adding plant:", error);
      setMessage("❌ Failed to add plant. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="container mt-5">
      <h3>Add Power Generation Plant</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Plant Name</label>
          <input
            type="text"
            name="genplant_name"
            className="form-control"
            value={formData.genplant_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Address</label>
          <textarea
            name="genplant_address"
            className="form-control"
            value={formData.genplant_address}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label>City</label>
            <input
              type="text"
              name="genplant_city"
              className="form-control"
              value={formData.genplant_city}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label>District</label>
            <input
              type="text"
              name="genplant_district"
              className="form-control"
              value={formData.genplant_district}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label>State</label>
            <input
              type="text"
              name="genplant_state"
              className="form-control"
              value={formData.genplant_state}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label>Pincode</label>
            <input
              type="text"
              name="genplant_pincode"
              className="form-control"
              value={formData.genplant_pincode}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label>Phone</label>
            <input
              type="text"
              name="genplant_phone"
              className="form-control"
              value={formData.genplant_phone}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label>Email</label>
            <input
              type="email"
              name="genplant_email"
              className="form-control"
              value={formData.genplant_email}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="mb-3">
          <label>Website</label>
          <input
            type="text"
            name="genplant_website"
            className="form-control"
            value={formData.genplant_website}
            onChange={handleChange}
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? "Saving..." : "Submit"}
        </button>

        {message && <div className="mt-3 alert alert-info">{message}</div>}
      </form>
    </div>
  );
};

export default AddPowerGenerationPlant;
